var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    fill: "none",
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.0734 23.9766L10.214 23.1469C9.91401 23.0625 9.74526 22.7485 9.82964 22.4485L16.2281 0.40784C16.3125 0.10784 16.6265 -0.06091 16.9265 0.023465L19.7859 0.853153C20.0859 0.937528 20.2546 1.25159 20.1703 1.55159L13.7718 23.5922C13.6828 23.8922 13.3734 24.0657 13.0734 23.9766V23.9766ZM7.72964 18.7172L9.7687 16.5422C9.98433 16.3125 9.97026 15.9469 9.7312 15.736L5.48433 12L9.7312 8.26409C9.97026 8.05315 9.98901 7.68753 9.7687 7.45784L7.72964 5.28284C7.5187 5.05784 7.16245 5.04378 6.93276 5.2594L0.178076 11.5875C-0.0609863 11.8078 -0.0609863 12.1875 0.178076 12.4078L6.93276 18.7407C7.16245 18.9563 7.5187 18.9469 7.72964 18.7172V18.7172ZM23.0671 18.7453L29.8218 12.4125C30.0609 12.1922 30.0609 11.8125 29.8218 11.5922L23.0671 5.25472C22.8421 5.04378 22.4859 5.05315 22.2703 5.27815L20.2312 7.45315C20.0156 7.68284 20.0296 8.04847 20.2687 8.2594L24.5156 12L20.2687 15.736C20.0296 15.9469 20.0109 16.3125 20.2312 16.5422L22.2703 18.7172C22.4812 18.9469 22.8375 18.9563 23.0671 18.7453V18.7453Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.7a07ff0db68b85b521bed060e8adea88.svg";
export { ForwardRef as ReactComponent };